import Axios from 'axios';

export const LogToBackend = (
   error,
   requestDetail = null,
   packedAllError = false,
) => {
   try {
      var errorObject = {};
      if (error.response) {
         errorObject.error = {};
         errorObject.error.data = error.response.data;
         errorObject.error.status = error.response.status;
         errorObject.error.header = error.response.headers;
      } else if (error.request) {
         errorObject.xmrError = error.request;
      } else {
         errorObject.unspecificedError = error.message;
      }

      if (error.config !== null && error.config !== undefined) {
         errorObject.method = error.config.method;
         errorObject.url = error.config.url;
      }

      if (packedAllError) {
         errorObject.allError = error.toJSON();
         errorObject.configuration = error.config;
      }

      if (requestDetail !== null && requestDetail !== undefined) {
         errorObject.request = requestDetail;
      }

      Axios.post(
         `${process.env.REACT_APP_URL_ENDPOINT}/` + 'GSB/log/azureLog',
         {
            jsonString: JSON.stringify(errorObject),
         },
      );
   } catch (error) {
      return false;
   }
};
